import { regexErrors, regexes, regexPlaceholders } from "./helper.js";
export let jobs = [
  { value: "Pegawai Negeri", label: "Pegawai Negeri" },
  { value: "Karyawan BUMN", label: "Karyawan BUMN" },
  { value: "TNI atau Polri", label: "TNI atau Polri" },
  { value: "Pegawai Swasta", label: "Pegawai Swasta" },
  { value: "Wiraswasta", label: "Wiraswasta" },
  { value: "Profesional", label: "Profesional" },
  { value: "Belum Bekerja", label: "Belum Bekerja" },
  { value: "Lainnya", label: "Lainnya" },
];
export let provinces = [];
export let cities = [
  {
    value: 0,
    label: "Pilih provinsi dahulu",
  },
];

export let districts = [
  {
    value: 0,
    label: "Pilih kota/kabupaten dahulu",
  },
];
export let subdistricts = [
  {
    value: 0,
    label: "Pilih kecamatan dahulu",
  },
];
export let faskesArray = [
  {
    value: 1,
    label: "Rumah Sakit Umum Daerah A",
  },
  {
    value: 2,
    label: "Klinik Dokter B",
  },
  {
    value: 3,
    label: "Puskesmas Daerah C",
  },
];
export let jkArray = [
  { value: "Laki-laki", label: "Laki-laki" },
  { value: "Perempuan", label: "Perempuan" },
];
export let gdArray = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "AB", label: "AB" },
  { value: "O", label: "O" },
];
export let pendArray = [
  { value: "Belum Sekolah", label: "Belum Sekolah" },
  { value: "Tidak Lulus SD", label: "Tidak Lulus SD" },
  { value: "SD", label: "Sekolah Dasar" },
  { value: "SMP", label: "Sekolah Menengah Pertama (SMP)" },
  { value: "SMA", label: "Sekolah Menengah Atas (SMA)" },
  { value: "S1", label: "Sarjana (S1)" },
  { value: "S2", label: "Magister (S2)" },
  { value: "S3", label: "Doktoral (S3)" },
];
export let agamaArray = [
  { value: "Islam", label: "Islam" },
  { value: "Kristen", label: "Kristen Protestan" },
  { value: "Katholik", label: "Kristen Katholik" },
  { value: "Hindu", label: "Hindu" },
  { value: "Buddha", label: "Buddha" },
  { value: "Konghuchu", label: "Konghuchu" },
];
export let nikahArray = [
  { value: "Belum Menikah", label: "Belum Menikah" },
  { value: "Menikah", label: "Menikah" },
  { value: "Janda/Duda", label: "Janda/Duda" },
];
export let idArray = [
  { value: "KTP", label: "KTP" },
  { value: "SIM", label: "SIM" },
  { value: "Paspor", label: "Paspor" },
];
export let keluargaArray = [
  { value: "Ayah", label: "Ayah" },
  { value: "Ibu", label: "Ibu" },
  { value: "Istri", label: "Istri" },
  { value: "Suami", label: "Suami" },
  { value: "Saudara", label: "Saudara" },
  { value: "Anak", label: "Anak" },
];
export let metodeArray = [
  { value: 1, label: "Umum" },
  { value: 2, label: "BPJS Kesehatan" },
  { value: 3, label: "Asuransi Lainnya" },
];
export let asuransiArray = [
  { value: 1, label: "Prudential" },
  { value: 2, label: "BNI Life Insurance" },
  { value: 3, label: "AXA Mandiri Insurance" },
];

export const sukuArray = [
  { value: "ARAB", label: "ARAB" },
  { value: "ASMAT", label: "ASMAT" },
  { value: "BALI", label: "BALI" },
  { value: "BATAK", label: "BATAK" },
  { value: "BUGIS", label: "BUGIS" },
  { value: "DAYAK", label: "DAYAK" },
  { value: "INGGRIS", label: "INGGRIS" },
  { value: "JAWA", label: "JAWA" },
  { value: "LUWU", label: "LUWU" },
  { value: "MADURA", label: "MADURA" },
  { value: "MELAYU", label: "MELAYU" },
  { value: "MINANG", label: "MINANG" },
  { value: "SALAYAN", label: "SALAYAN" },
  { value: "SASAK", label: "SASAK" },
  { value: "SUNDA", label: "SUNDA" },
  { value: "SUNDU BUHUN", label: "SUNDU BUHUN" },
  { value: "TIONGHOA", label: "TIONGHOA" },
];

export let leftForm = [
  {
    colnum: 2,
    columns: [
      { name: "no_rm", type: "text", label: "No Rekam Medis", readonly: true },
    ],
  },
  {
    colnum: 1,
    columns: [{ name: "nama", type: "text", label: "Nama Pasien" }],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "jen_kelamin",
        type: "radio",
        label: "Jenis Kelamin",
        options: jkArray,
      },
      {
        name: "gol_darah",
        type: "radio",
        label: "Golongan Darah",
        options: gdArray,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      { name: "tmp_lahir", type: "text", label: "Tempat Lahir" },
      {
        name: "tgl_lahir",
        type: "manualDate",
        label: "Tanggal Lahir",
        age_count: true,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "pendidikan",
        type: "select",
        label: "Pendidikan Terakhir",
        options: pendArray,
        value: "1",
      },
      { name: "nama_ibu", type: "text", label: "Nama Ibu Kandung" },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "agama",
        type: "select",
        label: "Agama",
        options: agamaArray,
      },
      {
        name: "status_nikah",
        type: "select",
        label: "Status Nikah",
        options: nikahArray,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "no_telp",
        type: "text",
        label: "Nomor Telepon",
        regex: regexes.phone,
        regexError: regexErrors.phone,
        placeholder: regexPlaceholders.phone,
      },
      { name: "pekerjaan", type: "select", label: "Pekerjaan", options: jobs },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "jenis_id",
        type: "radio",
        label: "Jenis Identitas",
        options: idArray,
        value: "KTP",
      },
      {
        name: "no_id",
        type: "text",
        label: "Nomor KTP",
        regexError: regexErrors.KTP,
        placeholder: regexPlaceholders.KTP,
        regex: regexes.KTP,
      },
    ],
  },
  {
    colnum: 1,
    columns: [{ name: "alamat", type: "text", label: "Alamat" }],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "id_provinsi",
        type: "select",
        label: "Provinsi",
        options: provinces,
      },
      {
        name: "id_kota",
        type: "select",
        label: "Kota/Kabupaten",
        options: cities,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "id_kecamatan",
        type: "select",
        label: "Kecamatan",
        options: districts,
      },
      {
        name: "id_kelurahan",
        type: "select",
        label: "Kelurahan/Desa",
        options: subdistricts,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "suku",
        type: "select",
        label: "Suku/Bangsa Pasien",
        options: sukuArray,
      },
      {
        name: "email",
        type: "email",
        label: "Email",
        regexError: regexErrors.email,
        placeholder: regexPlaceholders.email,
        regex: regexes.email,
      },
    ],
  },
];
export let rightForm = [
  {
    colnum: 1,
    columns: [
      {
        name: "pj_jenis",
        type: "radio",
        label: "Penanggung Jawab",
        options: keluargaArray,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      { name: "pj_nama", type: "text", label: "Nama Penanggung Jawab" },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pj_pekerjaan",
        type: "select",
        label: "Pekerjaan",
        options: jobs,
      },
    ],
  },
  {
    colnum: 1,
    columns: [{ name: "pj_alamat", type: "text", label: "Alamat" }],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "id_provinsi_pj",
        type: "select",
        label: "Provinsi",
        options: provinces,
      },
      {
        name: "id_kota_pj",
        type: "select",
        label: "Kota/Kabupaten",
        options: cities,
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "id_kecamatan_pj",
        type: "select",
        label: "Kecamatan",
        options: districts,
      },
      {
        name: "id_kelurahan_pj",
        type: "select",
        label: "Kelurahan/Desa",
        options: subdistricts,
      },
    ],
  },
];
export let rightFormBottom = [
  {
    colnum: 1,
    columns: [
      {
        name: "id_asuransi",
        type: "radio",
        value: 1,
        label: "Metode Pembayaran",
        options: metodeArray,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        name: "asuransi_lain",
        type: "hidden",
        label: "Pilih Asuransi",
        options: asuransiArray,
      },
    ],
  },
  {
    colnum: 1,
    columns: [{ name: "no_peserta", type: "hidden", label: "Nomor Peserta" }],
  },
  {
    colnum: 1,
    columns: [
      {
        name: "asal_faskes",
        type: "hidden",
        label: "Asal Faskes",
        action: "/#/master/faskes/form",
        actionText: "Tambah Faskes Baru",
        actionIcon: "add",
        refresh: () => {},
        options: [],
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        name: "foto",
        type: "image",
        label: "Upload Foto Pasien",
        additional: "Gambar .jpg,.png maksimal 2MB",
        optional: true,
      },
    ],
  },
];
